import { AiFillCheckCircle } from '@react-icons/all-files/ai/AiFillCheckCircle';
import { ZorbaButton } from '../../../../../../components/forms';

import './index.scss';

export const SuccessfulSubmission = ({ onReset }) => (
  <div className="bulk-submitted-to-underwriting-step valid">
    <AiFillCheckCircle />
    <div className="title">Submission Successful</div>
    <p className="description">
      Our team will underwrite your deals within 24-72 hours. If you have any
      questions about the process, feel free to reach out to us at
      <a href="mailto:acquisitions@zorbapartners.com" className="link">
        {' '}
        acquisitions@zorbapartners.com
      </a>
    </p>
    <div className="buttons">
      <div className="button-wrapper">
        <ZorbaButton onClick={onReset} fullWidth={false}>
          Close
        </ZorbaButton>
      </div>
    </div>
  </div>
);
